import React, { useEffect, useState, useCallback } from "react";
import { Search, Fingerprint, ExternalLink } from "lucide-react";
import api from "@/lib/api";

const IdentitiesAdmin = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = useCallback(() => {
    api.get("/admin/identities", { params: q ? { q } : {} }).then((r) => setItems(r.data)).catch(() => {});
  }, [q]);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="flex flex-col sm:flex-row justify-between gap-4 mb-6">
        <h2 className="font-heading text-2xl text-brown-black flex items-center gap-2"><Fingerprint size={22} className="text-gold" /> Identités digitales / Achats ({items.length})</h2>
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-brown-black/40" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Nom, e-mail, produit, identifiant, transaction PayPal…"
            data-testid="identities-search"
            className="pl-9 pr-3 py-2.5 w-full sm:w-96 rounded-full border border-gold/25 bg-white focus:border-gold focus:outline-none text-sm"
          />
        </div>
      </div>

      {items.length === 0 ? (
        <p className="text-center text-brown-black/50 py-16 flex flex-col items-center gap-3"><Fingerprint size={32} className="text-gold/40" /> Aucune identité digitale pour le moment.</p>
      ) : (
        <div className="bg-white rounded-xl border border-gold/15 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-ivory text-brown-dark/70 text-left">
                <tr>
                  <th className="px-4 py-3 font-semibold">Identité digitale</th>
                  <th className="px-4 py-3 font-semibold">Client</th>
                  <th className="px-4 py-3 font-semibold">Produit(s)</th>
                  <th className="px-4 py-3 font-semibold">Montant</th>
                  <th className="px-4 py-3 font-semibold">Transaction PayPal</th>
                  <th className="px-4 py-3 font-semibold">Date</th>
                  <th className="px-4 py-3 font-semibold">Vérifier</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.digital_id} className="border-t border-gold/10 hover:bg-ivory/50" data-testid={`identity-row-${it.digital_id}`}>
                    <td className="px-4 py-3 font-mono font-bold text-gold">{it.digital_id}</td>
                    <td className="px-4 py-3">{it.customer_name}<br /><span className="text-brown-black/50 text-xs">{it.customer_email}</span></td>
                    <td className="px-4 py-3 max-w-[220px]">{(it.products || []).join(", ")}</td>
                    <td className="px-4 py-3 font-semibold text-brown-dark">{Number(it.amount).toFixed(2)} {it.currency}</td>
                    <td className="px-4 py-3 font-mono text-xs">{it.transaction_id || "—"}</td>
                    <td className="px-4 py-3 text-brown-black/60 text-xs">{new Date(it.purchase_date).toLocaleString("fr-FR")}</td>
                    <td className="px-4 py-3">
                      <a href={`/verification/${it.digital_id}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-gold hover:underline text-xs font-semibold" data-testid={`identity-verify-${it.digital_id}`}>
                        <ExternalLink size={13} /> Page
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default IdentitiesAdmin;
